import React, { createContext, useContext, useState } from 'react';

interface ClientInfo {
  // Campos básicos individuales (estos son fijos y siguen la estructura de la API)
  importid: string;
  recordid: string;
  companyname?: string;
  customername?: string;
  customerphone?: string;
  customertrn?: string;
  customerreference?: string;
  customerdob?: Date;
  customerfathername?: string;
  customeraddress?: string;
  customeremail?: string;
  customeriscompany?: number;

  // Contextos como objetos dinámicos sin campos predefinidos
  // eslint-disable-next-line
  callcontext?: Record<string, any>; // Cualquier par clave-valor
  // eslint-disable-next-line
  bxpcontext?: Record<string, any>; // Cualquier par clave-valor
}

export interface FeedbackMessage {
  id: string;
  timestamp: Date;
  type: 'info' | 'validation' | 'transfer' | 'close';
  message: string;
  details?: string;
  success?: boolean;
}

interface HVAConversationContextType {
  clientInfo: ClientInfo | null;
  setClientInfo: (info: ClientInfo) => void;
  isNifValidated: boolean;
  setIsNifValidated: (validated: boolean) => void;
  isDobValidated: boolean;
  setIsDobValidated: (validated: boolean) => void;
  requestTransfer: boolean;
  setRequestTransfer: (transfer: boolean) => void;
  conversationResults: string;
  setConversationResults: (
    results: string | ((prev: string) => string)
  ) => void;
  // Nuevas propiedades para mejorar el flujo
  isCallActive: boolean;
  setIsCallActive: (active: boolean) => void;
  currentCallId: string | null;
  setCurrentCallId: (callId: string | null) => void;
}

const HVAConversationContext = createContext<
  HVAConversationContextType | undefined
>(undefined);

export const HVAConversationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [clientInfo, setClientInfo] = useState<ClientInfo | null>(null);
  const [isNifValidated, setIsNifValidated] = useState(false);
  const [isDobValidated, setIsDobValidated] = useState(false);
  const [requestTransfer, setRequestTransfer] = useState(false);
  const [conversationResults, setConversationResults] = useState('');
  const [isCallActive, setIsCallActive] = useState(false);
  const [currentCallId, setCurrentCallId] = useState<string | null>(null);

  const value = {
    clientInfo,
    setClientInfo,
    isNifValidated,
    setIsNifValidated,
    isDobValidated,
    setIsDobValidated,
    requestTransfer,
    setRequestTransfer,
    conversationResults,
    setConversationResults,
    isCallActive,
    setIsCallActive,
    currentCallId,
    setCurrentCallId
  };

  return (
    <HVAConversationContext.Provider value={value}>
      {children}
    </HVAConversationContext.Provider>
  );
};

export const useHVAConversation = () => {
  const context = useContext(HVAConversationContext);
  if (context === undefined) {
    throw new Error(
      'useHVAConversation must be used within a HVAConversationProvider'
    );
  }
  return context;
};

export interface HVADynamicConversationModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  agentCode: string;
  agentName: string;
  campaignId: number;
  agentImage?: string;
  onError?: (error: Error) => void;
  customer?: string;
  trn?: string;
  dateOfBirth?: Date;
  debtamount?: number;
  currency?: string;
  origin?: string;
  companyName?: string;
  customerReference?: string;
  customerEmail?: string;
  customerAddress?: string;
  importid?: string;
  recordid?: string;
}
